// Generated by @repo/server. Do not edit.
import buildTimeData from "./build-time-data.json";
import { registerStaticSnapshot } from "@repo/server";

registerStaticSnapshot(buildTimeData);

export { useFindData } from "./useFindData";
export type { UseFindDataReturn } from "./useFindData";
export { applicationSchemas } from "./schema";
export type { Application } from "./schema";
export { default as buildTimeData } from "./build-time-data.json";
export type {
  BuildTimeData,
  DownloadedFile,
  FileRecord,
  FileClass,
  EmailClass,
  LocationClass,
  EventClass,
  PersonClass,
  CategoryClass,
  EntryClass,
  DownloadClass,
  WebpageClass,
  ImageClass,
  UserClass,
} from "./types";
